export const LtcMembers = [
  // --- Legal ---
  { title: 'Mr.', firstName: 'James', lastName: 'Bauld', type: 'Legal' },
  { title: 'Ms.', firstName: 'Barbara', lastName: 'Black/Kean', type: 'Legal' },
  { title: 'Miss.', firstName: 'Valerie', lastName: 'Bremner', type: 'Legal' },
  { title: 'Ms.', firstName: 'Louise', lastName: 'Carlin', type: 'Legal' },
  { title: 'Mr.', firstName: 'Kevin', lastName: 'Duffy', type: 'Legal' },
  { title: 'Mr.', firstName: 'Graham', lastName: 'Dunlop', type: 'Legal' },
  { title: 'Mrs.', firstName: 'Mary', lastName: 'Forbes', type: 'Legal' },
  { title: 'Mr.', firstName: 'Alastair', lastName: 'Houston', type: 'Legal' },
  { title: 'Miss.', firstName: 'Nicola', lastName: 'Irvine', type: 'Legal' },
  { title: 'Mr.', firstName: 'William', lastName: 'Lane', type: 'Legal' },
  { title: 'Mrs.', firstName: 'Hilary', lastName: 'Macandrew', type: 'Legal' },
  { title: 'Mr.', firstName: 'Iain', lastName: 'MacRae', type: 'Legal' },
  { title: 'Mrs.', firstName: 'Elise', lastName: 'McIntyre', type: 'Legal' },
  { title: 'Miss.', firstName: 'Yvonne', lastName: 'McKenna', type: 'Legal' },
  { title: 'Mr.', firstName: 'Andrew', lastName: 'McLaughlin', type: 'Legal' },
  { title: 'Mrs.', firstName: 'Laura', lastName: 'McLaughlin', type: 'Legal' },
  { title: 'Mr.', firstName: 'Rick', lastName: 'Mill', type: 'Legal' },
  { title: 'Ms.', firstName: 'Gabrielle', lastName: 'Miller', type: 'Legal' },
  { title: 'Mr.', firstName: 'Mark', lastName: 'Thorley', type: 'Legal' },
  { title: 'Mr.', firstName: 'John', lastName: 'Walker', type: 'Legal' },
  { title: 'Mrs.', firstName: 'Sarah', lastName: 'Walker', type: 'Legal' },
  { title: 'Mrs.', firstName: 'Fiona', lastName: 'Watson', type: 'Legal' },
  { title: 'Ms.', firstName: 'Laura', lastName: 'Wilkinson', type: 'Legal' },
  { title: 'Miss.', firstName: 'Pamela', lastName: 'Woodman', type: 'Legal' },

  // --- Ordinary (Rating Experience) ---
  { title: 'Mr.', firstName: 'Nicholas', lastName: 'Allan', type: 'Ordinary (Rating Experience)' },
  { title: 'Mr.', firstName: 'Gavin', lastName: 'Falconer', type: 'Ordinary (Rating Experience)' },
  { title: 'Mr.', firstName: 'Alastair', lastName: 'Hainey', type: 'Ordinary (Rating Experience)' },
  { title: 'Mrs.', firstName: 'Sara', lastName: 'Hesp', type: 'Ordinary (Rating Experience)' },
  { title: 'Mr.', firstName: 'David', lastName: 'Thomson', type: 'Ordinary (Rating Experience)' },
  { title: 'Mr.', firstName: 'Donald', lastName: 'Wooley', type: 'Ordinary (Rating Experience)' },
  { title: 'Mrs.', firstName: 'Geraldine', lastName: 'Wooley', type: 'Ordinary (Rating Experience)' },

  // --- Ordinary (Valuation Experience) ---
  { title: 'Mr.', firstName: 'Gordon', lastName: 'Anderson', type: 'Ordinary (Valuation Experience)' },
  { title: 'Mrs.', firstName: 'Alison', lastName: 'Blaney', type: 'Ordinary (Valuation Experience)' },
  { title: 'Mr.', firstName: 'Kingsley', lastName: 'Bruce', type: 'Ordinary (Valuation Experience)' },
  { title: 'Mr.', firstName: 'John', lastName: 'Flynn', type: 'Ordinary (Valuation Experience)' },
  { title: 'Mr.', firstName: 'David', lastName: 'Godfrey', type: 'Ordinary (Valuation Experience)' },
  { title: 'Mrs.', firstName: 'Patricia', lastName: 'Marshall', type: 'Ordinary (Valuation Experience)' },
  { title: 'Mr.', firstName: 'Peter', lastName: 'McEachran', type: 'Ordinary (Valuation Experience)' },
  { title: 'Mr.', firstName: 'Paul', lastName: 'Walker', type: 'Ordinary (Valuation Experience)' },
  { title: 'Mr.', firstName: 'Robert', lastName: 'Walsh', type: 'Ordinary (Valuation Experience)' },
  { title: 'Ms.', firstName: 'Sheena', lastName: 'West', type: 'Ordinary (Valuation Experience)' },
];
